(function(scope){
  'use strict';
  const states=new WeakMap();
  const money=cents=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100);
  function matchesAction(action,campaign){
    return Boolean(campaign&&(!action||action==='auto'||action===campaign.code));
  }
  function select(products,config,engine,at,campaign,family=''){
    if(!campaign||engine.activeCampaign(config,at)?.code!==campaign.code)return [];
    return products.filter(product=>(!family||product.families.some(item=>item.id===family))&&product.variants.some(variant=>
      engine.calculate(config,{at,customer:'new',pix:false,lines:[{productId:product.id,variantId:variant.id,quantity:1,price:variant.price}]}).lines[0].percent>0));
  }
  function families(products){
    const result=new Map();
    for(const product of products)for(const family of product.families)if(!result.has(family.id))result.set(family.id,family);
    return [...result.values()].sort((a,b)=>a.title.localeCompare(b.title,'pt-BR'));
  }
  function page(items,current,size){
    const pages=Math.max(1,Math.ceil(items.length/size)),number=Math.min(pages,Math.max(1,current));
    return {number,pages,items:items.slice((number-1)*size,number*size)};
  }
  function render(root,options){
    let state=states.get(root);
    if(!state){
      const catalog=JSON.parse(root.querySelector('[data-eb-grid-products]').textContent);
      if(!catalog.complete){root.hidden=true;return;}
      const copy=JSON.parse(root.querySelector('[data-eb-grid-copy]').textContent);
      state={products:catalog.products,copy,family:'',page:1,code:null,cards:new Map([...root.querySelectorAll('[data-eb-native-products] > .product-card')].map(card=>[card.dataset.productId,card]))};
      state.size=Number(root.dataset.pageSize)||20;states.set(root,state);
    }
    state.options=options;
    const {campaign,config,engine,at,copy}=options;
    const allowed=matchesAction(root.dataset.ebAction,campaign),notice=root.parentElement.querySelector('[data-eb-action-notice]');
    if(notice)notice.hidden=allowed;
    if(!allowed){root.hidden=true;return;}
    const participating=select(state.products,config,engine,at,campaign);
    const available=families(participating);
    if(state.code!==campaign.code){state.code=campaign.code;state.family='';state.page=1;}
    if(state.family&&!available.some(f=>f.id===state.family)){state.family='';state.page=1;}
    root.hidden=false;
    if(root.querySelector('.eb-black-collection__header')){
      root.querySelector('[data-eb-grid-title]').textContent=copy['action_'+campaign.code.toLowerCase()];
      const rates=[...new Set(campaign.tiers.map(t=>t.percent+'% OFF'))];
      if(campaign.generalPercent)rates.push(campaign.generalPercent+'% OFF '+copy.general);
      root.querySelector('[data-eb-grid-rate]').textContent=rates.join(' · ')+(campaign.quantityCap!==null?' · '+state.copy.limit:'');
      const gift=root.querySelector('[data-eb-grid-gift]');
      const giftAllowed=options.giftAllowed!==false;
      gift.hidden=!giftAllowed;
      gift.textContent=(campaign.minimumNew===null?state.copy.gift_returning.replace('{gift}',campaign.giftName).replace('{returning}',money(campaign.minimumReturning)):state.copy.gift_summary.replace('{gift}',campaign.giftName).replace('{new}',money(campaign.minimumNew)).replace('{returning}',money(campaign.minimumReturning)))+' '+state.copy.gift_basis;
    }
    const nav=root.querySelector('[data-eb-families]'),signature=JSON.stringify(available);
    if(state.familySignature!==signature){
      state.familySignature=signature;nav.replaceChildren();
      for(const family of [{id:'',title:state.copy.all},...available]){
        const button=document.createElement('button');button.type='button';button.textContent=family.title;button.dataset.ebFamily=family.id;button.setAttribute('aria-pressed','false');
        button.addEventListener('click',()=>{state.family=family.id;state.page=1;draw(root,state);root.scrollIntoView({block:'start',behavior:'instant'});});nav.append(button);
      }
    }
    draw(root,state);
  }
  function draw(root,state){
    const {campaign,config,engine,at}=state.options;
    const selected=select(state.products,config,engine,at,campaign,state.family),current=page(selected,state.page,state.size);state.page=current.number;
    const visible=new Set(current.items.map(p=>p.id));
    for(const [id,card] of state.cards)card.hidden=!visible.has(id);
    for(const button of root.querySelectorAll('[data-eb-family]'))button.setAttribute('aria-pressed',String(button.dataset.ebFamily===state.family));
    root.querySelector('[data-eb-grid-count]').textContent=selected.length===1?state.copy.count_one:state.copy.count.replace('{count}',String(selected.length));
    root.querySelector('[data-eb-grid-empty]').hidden=selected.length>0;
    const pagination=root.querySelector('[data-eb-grid-pagination]');pagination.hidden=current.pages<=1;pagination.replaceChildren();
    if(current.pages>1){
      const list=document.createElement('ul');list.className='pagination__list';
      for(let number=1;number<=current.pages;number++){
        const item=document.createElement('li'),button=document.createElement('button');item.className='page d-inline-block';button.type='button';button.textContent=String(number);button.setAttribute('aria-label',state.copy.page.replace('{number}',String(number)));
        if(number===current.number)button.setAttribute('aria-current','page');
        button.addEventListener('click',()=>{state.page=number;draw(root,state);root.querySelector('[data-eb-families]').scrollIntoView({block:'start',behavior:'instant'});});item.append(button);list.append(item);
      }
      pagination.append(list);
    }
    root.dataset.ebCampaign=campaign.code;root.dataset.ebParticipantCount=String(select(state.products,config,engine,at,campaign).length);root.dataset.ebFilteredCount=String(selected.length);root.dataset.ebPage=String(current.number);
    root.dispatchEvent(new CustomEvent('elyah:black-grid:updated',{bubbles:true}));
  }
  scope.ElyahBlackCollection=Object.freeze({select,families,page,render,matchesAction});
})(typeof window!=='undefined'?window:globalThis);
